import { EmployerEmploymentInput, EmployerUpdateHireInput } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { gql } from "@apollo/client"
import { RemoteWorkCostsFragment } from "~/shared/fragments/RemoteWorkCostsFragment"

const HIRING_FTE_COMPANY_UPDATE_REMOTE_WORK_COST = gql`
  mutation HiringFTECompanyUpdateRemoteWorkCost($input: EmployerUpdateHireInput!) {
    employerUpdateHire(input: $input) {
      employment {
        id
        ...RemoteWorkCostsFragment
      }
      errors
    }
  }

  ${RemoteWorkCostsFragment}
`

export type UseNewHireEquipmentRemoteWorkCostMutationOptions = InjectedOptions<
  Pick<EmployerUpdateHireInput, "employmentId"> & Pick<EmployerEmploymentInput, "remoteWorkCosts">
>
export const useNewHireEquipmentRemoteWorkCostMutation = (
  options: UseNewHireEquipmentRemoteWorkCostMutationOptions,
) =>
  useMutation(HIRING_FTE_COMPANY_UPDATE_REMOTE_WORK_COST, {
    ...options,
  })
